var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95 11.1004H5.34C4.83595 11.1004 4.58393 11.1004 4.39141 11.1985C4.22206 11.2848 4.08438 11.4225 3.99809 11.5918C3.9 11.7843 3.9 12.0363 3.9 12.5404V20.1004M16.05 11.1004H18.66C19.164 11.1004 19.4161 11.1004 19.6086 11.1985C19.7779 11.2848 19.9156 11.4225 20.0019 11.5918C20.1 11.7843 20.1 12.0363 20.1 12.5404V20.1004M16.05 20.1004V6.78039C16.05 5.7723 16.05 5.26825 15.8538 4.88321C15.6812 4.54452 15.4059 4.26915 15.0672 4.09658C14.6821 3.90039 14.1781 3.90039 13.17 3.90039H10.83C9.82191 3.90039 9.31786 3.90039 8.93282 4.09658C8.59413 4.26915 8.31876 4.54452 8.14619 4.88321C7.95 5.26825 7.95 5.7723 7.95 6.78039V20.1004M21 20.1004H3M11.1 7.50039H12.9M11.1 11.1004H12.9M11.1 14.7004H12.9",
    stroke: "#0098A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatching);
export default __webpack_public_path__ + "c7b2b0112bb41f1b5f1474a6f5891ae7.svg";
export { ForwardRef as ReactComponent };